<template functional>
  <v-row
    class="fill-height reload-on-error d-flex flex-column"
    align="center"
    justify="center"
  >
    <div v-if="props.failedToLoadText">
      <h3 class="reload-on-error__message text-center">
        {{ props.failedToLoadText }}
      </h3>
    </div>
    <div>
      <VBtn
        rounded
        class="mt-3 reload-on-error__button"
        @click="listeners['reload'] && listeners['reload']()"
      >
        <StIcon
          class="mr-2"
          icon-name="reload"
        />
        {{ props.reloadButtonText }}
      </VBtn>
    </div>
  </v-row>
</template>

<script>
import Vue from 'vue';
import { VBtn } from 'vuetify/lib';
import StIcon from '@stilingue/st-icon/StIcon';

Vue.component('StIcon', StIcon);

export default {
  name: 'StReloadOnError',
  components: {
    StIcon,
    VBtn
  },
  props: {
    failedToLoadText: {
      type: String,
      default: ''
    },
    reloadButtonText: {
      type: String,
      default: 'Recarregar'
    }
  }
};
</script>
